import React from 'react';

export function Ghana(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H513V114H0V0Z" fill="#006B3F"/>
      <path d="M0 114H513V228H0V114Z" fill="#FCD116"/>
      <path d="M0 228H513V342H0V228Z" fill="#CE1126"/>
      <polygon points="256.5,95 267,128 302,128 274,148 284,181 256.5,161 229,181 239,148 211,128 246,128" fill="#1E1E1E"/>
    </svg>
  );
}
